import * as entityHandlers from '../../../modules/bin/entityHandlers';
import config from '../../../constants';

// Action Types
export const GET_REQUESTED = 'fundraiser/GET_REQUESTED';
export const GET_SUCCESS = 'fundraiser/GET_SUCCESS';
export const GET_FAILURE = 'fundraiser/GET_FAILURE';

export const FRANCHISE_HISTORY_REQUESTED = 'fundraiser/FRANCHISE_HISTORY_REQUESTED';
export const FRANCHISE_HISTORY_SUCCESS = 'fundraiser/FRANCHISE_HISTORY_SUCCESS';
export const FRANCHISE_HISTORY_FAILURE = 'fundraiser/FRANCHISE_HISTORY_FAILURE';

export const MARK_SPAM_REQUESTED = 'fundraiser/MARK_SPAM_REQUESTED';
export const MARK_SPAM_SUCCESS = 'fundraiser/MARK_SPAM_SUCCESS';
export const MARK_SPAM_FAILURE = 'fundraiser/MARK_SPAM_FAILURE';
export const MARK_SPAM_CONFIRMATION_SHOW = 'fundraiser/MARK_SPAM_CONFIRMATION_SHOW';
export const MARK_SPAM_CONFIRMATION_HIDE = 'fundraiser/MARK_SPAM_CONFIRMATION_HIDE';

export const ERROR_CLEAR = 'fundraiser/ERROR_CLEAR';

// Action Creators
export const getRecord = (id: any) =>
    entityHandlers.getRecord(
        'page/fundraiser',
        GET_REQUESTED,
        GET_SUCCESS,
        GET_FAILURE,
        id
    );

export const getFranchiseHistory = (franchiseId: number, accountId: number) =>
    entityHandlers.getSearchRecord(
        'page',
        FRANCHISE_HISTORY_REQUESTED,
        FRANCHISE_HISTORY_SUCCESS,
        FRANCHISE_HISTORY_FAILURE,
        {
            page: 1,
            pageSize: 50,
            resultType: 'Full',
            filters: [
                {
                    key: 'franchiseId',
                    operator: 'EqualTo',
                    value: [franchiseId]
                },
                {
                    key: 'accountId',
                    operator: 'EqualTo',
                    value: [accountId]
                }
            ]
        },
        'franchiseHistory',
        'v3'
    );

export const markAsSpam = (id: number) =>
    entityHandlers.executeRequest(
        `${config.baseApiHost}/api/v2/page/fundraiser/${id}/mark-spam`,
        'POST',
        MARK_SPAM_REQUESTED,
        MARK_SPAM_SUCCESS,
        MARK_SPAM_FAILURE,
        null,
        null,
        'saveRecord'
    );

export const showMarkSpamConfirmation = () => ({
    type: MARK_SPAM_CONFIRMATION_SHOW
});

export const hideMarkSpamConfirmation = () => ({
    type: MARK_SPAM_CONFIRMATION_HIDE
});

export const clearRecordMessages = (recordKey: any) => ({
    type: ERROR_CLEAR,
    payload: { key: recordKey }
});
